import { Customer } from '../types';

export enum ActionTypes {
    GetCustomers = '[customers] GET_CUSTOMERS',
    GetCustomersCount = '[customers] GET_CUSTOMERS_COUNT',
    FetchCustomersResponse = '[customers] FETCH_CUSTOMERS_RESPONSE',
    FetchNextResponse = '[customers] FETCH_NEXT_RESPONSE',
    FetchTotalCountResponse = '[customers] FETCH_TOTAL_COUNT_RESPONSE',
}

export enum GetCustomersReason {
    mount = 'mount',
    update = 'update',
    next = 'next',
    refresh = 'refresh',
}

export interface GetCustomers {
    type: ActionTypes.GetCustomers;
    payload: {
        accountId: string;
        params: URLSearchParams;
        requestId: number;
        reason: GetCustomersReason;
    };
}
export interface GetCustomersCount {
    type: ActionTypes.GetCustomersCount;
    payload: {
        accountId: string;
    };
}

export interface FetchCustomersResponse {
    type: ActionTypes.FetchCustomersResponse;
    payload: {
        customers: Customer[];
    };
    meta: {
        cause: GetCustomers;
    };
}

export interface FetchCustomersTotalCountResponse {
    type: ActionTypes.FetchTotalCountResponse;
    payload: {
        totalCount: number;
    };
    meta: {
        cause: GetCustomersCount;
    };
}

export interface FetchNextResponse {
    type: ActionTypes.FetchNextResponse;
    payload: {
        customers: Customer[];
    };
    meta: {
        cause: FetchCustomersResponse;
    };
}

export function getCustomers(
    accountId: string,
    params: URLSearchParams,
    reason: GetCustomersReason
): GetCustomers {
    return {
        type: ActionTypes.GetCustomers,
        payload: {
            accountId,
            params,
            reason,
            requestId: performance.now(),
        },
    };
}

export function getCustomersCount(
    accountId: string
): GetCustomersCount {
    return {
        type: ActionTypes.GetCustomersCount,
        payload: {
            accountId,
        },
    };
}

export type Actions = GetCustomers | FetchCustomersResponse | FetchNextResponse | FetchCustomersTotalCountResponse;
